module.exports = __webpack_public_path__ + "static/media/Group 3@2x.49a384cf.png";